import normalizer from '@cordel/helpers/form/schema';

// eslint-disable-next-line import/no-extraneous-dependencies
import { SORT_METHODS } from '@/_CRUDL/helpers/data/sort';

import {
  FILTERS,
} from './sections';

import {
  SELLER_ID,
  STORE_ID,
  BANK_CODE,
  SORT,
} from './fields';

export default function schema() {
  return normalizer({
    sections: {
      [FILTERS]: {},
    },

    fields: {
      [STORE_ID]: {
        section: FILTERS,
        type: 'select',
        label: 'Loja',
        labelless: true,
        placeholder: 'Filtrar por loja',
        size: 3,
      },
      [SELLER_ID]: {
        section: FILTERS,
        type: 'select',
        label: 'Vendedor',
        labelless: true,
        placeholder: 'Filtrar por vendedor',
        size: 3,
      },
      [BANK_CODE]: {
        section: FILTERS,
        type: 'select',
        label: 'Banco',
        labelless: true,
        placeholder: 'Filtrar por banco',
        size: 3,
      },
      [SORT]: {
        section: FILTERS,
        type: 'select',
        label: 'Ordenação',
        labelless: true,
        placeholder: 'Ordenação dos resultados',
        size: 3,
        options: Object.values(SORT_METHODS),
        value: SORT_METHODS.created_at_desc.value,
      },
    },
  });
}
